"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = rooms;

var _RoomsActionTypes = require("../constants/action-types/RoomsActionTypes");

var types = _interopRequireWildcard(_RoomsActionTypes);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var initialState = {
  list: [],
  challenges: [],
  isFetching: false
};

function rooms() {
  var rooms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case types.FETCH_ROOMS_SUCCESS:
      return setRoomsList(rooms, payload);

    case types.FETCH_CHALLENGES_SUCCESS:
      return setChallenges(rooms, payload);

    case types.CREATE_ROOM_FAILURE:
    case types.FETCH_ROOMS_FAILURE:
    case types.FETCH_CHALLENGES_FAILURE:
      return handleError(rooms, payload);

    case types.LOADING_REQUEST:
      return loading(rooms);

    default:
      return rooms;
  }
}

var setRoomsList = function setRoomsList(rooms, _ref2) {
  var list = _ref2.list;
  return _extends({}, rooms, {
    isFetching: false,
    list: list
  });
};

var setChallenges = function setChallenges(rooms, _ref3) {
  var challenges = _ref3.challenges;
  return _extends({}, rooms, {
    isFetching: false,
    challenges: challenges
  });
};

var handleError = function handleError(rooms) {
  return _extends({}, rooms, {
    isFetching: false
  });
};

var loading = function loading(rooms) {
  return _extends({}, rooms, {
    isFetching: true
  });
};